import { combineReducers } from 'redux';
import adminJobsReducer from '@sonifi/wb-admin/store/jobs/jobsSlice';
import adminUsersReducer from '@sonifi/wb-admin/store/users/usersSlice';
import applicationReducer from './application/applicationSlice';
import brandingReducer from '@sonifi/wb-branding/store/brandingSlice';
import fileReducer from '@sonifi/wb-widget/store/file/fileSlice';
import formErrorsReducer from '@sonifi/wb-widget/store/formErrors/formErrorsSlice';
import guestRequestMenuReducer from '@sonifi/wb-guest-request/store/menu/guestRequestMenuSlice';
import guestRequestOrdersReducer from '@sonifi/wb-guest-request/store/orders/guestRequestOrdersSlice';
import guestRequestSettingsReducer from '@sonifi/wb-guest-request/store/settings/guestRequestSettingsSlice';
import groupsReducer from '@sonifi/wb-group/store/groupsSlice';
import happeningsReducer from '@sonifi/wb-happenings/store/happeningsSlice';
import happeningsSlideEditorReducer from '@sonifi/wb-happenings/store/happeningsSlideEditorSlice';
import homeReducer from '@sonifi/wb-home/store/homeSlice';
import hotelDirectoryReducer from '@sonifi/wb-hotel-directory/store/hotelDirectorySlice';
import mediaReducer from '@sonifi/wb-media/store/mediaSlice';
import notifierReducer from '@sonifi/wb-notifier/store/notifierSlice';
import tableConfigReducer from '@sonifi/wb-widget/store/tableConfig/tableConfigSlice';
import userReducer from '@sonifi/wb-user/store/userSlice';
import selfServiceReducer from '@sonifi/wb-remote-ordering/store/selfServiceSlice';
import productsReducer from '@sonifi/wb-products/store/productsSlice';
import adminPropertiesReducer from '@sonifi/wb-admin/store/properties/propertiesSlice';
import irdOrdersReducer from '@sonifi/wb-in-room-dining/store/orders/irdOrdersSlice';
import irdSettingsReducer from '@sonifi/wb-in-room-dining/store/settings/irdSettingsSlice';
import irdMenuReducer from '@sonifi/wb-in-room-dining/store/menu/irdMenuSlice';

export default combineReducers({
  adminJobs: adminJobsReducer,
  adminProperties: adminPropertiesReducer,
  adminUsers: adminUsersReducer,
  application: applicationReducer,
  branding: brandingReducer,
  file: fileReducer,
  formErrors: formErrorsReducer,
  groups: groupsReducer,
  guestRequestMenu: guestRequestMenuReducer,
  guestRequestOrders: guestRequestOrdersReducer,
  guestRequestSettings: guestRequestSettingsReducer,
  happenings: happeningsReducer,
  happeningsSlideEditor: happeningsSlideEditorReducer,
  home: homeReducer,
  hotelDirectory: hotelDirectoryReducer,
  irdMenu: irdMenuReducer,
  irdOrders: irdOrdersReducer,
  irdSettings: irdSettingsReducer,
  media: mediaReducer,
  notifier: notifierReducer,
  products: productsReducer,
  selfService: selfServiceReducer,
  tableConfig: tableConfigReducer,
  user: userReducer,
});
